import { render, staticRenderFns } from "./SLayout.vue?vue&type=template&id=4b1a8107&scoped=true"
import script from "./SLayout.vue?vue&type=script&lang=js"
export * from "./SLayout.vue?vue&type=script&lang=js"
import style0 from "./SLayout.vue?vue&type=style&index=0&id=4b1a8107&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b1a8107",
  null
  
)

export default component.exports